'use strict'

import { apiInstance, legacyV2 } from './index'
import { mapArgs } from 'utils/functions'

const creditPolicy = {
  getCreditPolicy (...args) {
    const params = mapArgs(...args)
    return apiInstance({
      method: 'GET',
      url: `${legacyV2()}/employee/rideCredit`,
      params
    })
  },

  updateCreditPolicy (data) {
    return apiInstance({
      method: 'PUT',
      url: `${legacyV2()}/employee/${data.employeeId}/rideCredit`,
      data
    })
  },

  deleteCreditPolicy (employeeId) {
    return apiInstance({
      method: 'DELETE',
      url: `${legacyV2()}/employee/${employeeId}/rideCredit`
    })
  }
}

export default creditPolicy
